import React from "react";
import { Dialog, DialogContent, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VendorCatalogUpload from "./VendorCatalogUpload";
import { catalogTokens } from "./VendorCatalogTheme";

// Thin Dialog shell around VendorCatalogUpload in replace mode — swaps an existing catalog's
// PDF for a newer one from the same vendor, prefilled with its current brand/category/
// sub-category/price tags (all still editable; only the vendor is fixed).
const VendorCatalogReplaceDialog = ({ catalog, open, onClose, onSuccess }) => {
  if (!catalog) return null;

  const initialValues = {
    vendor: { id: catalog.vendorId, legalVendorName: catalog.vendorName },
    categories: catalog.categories || [],
    brands: catalog.brands || [],
    subCategories: (catalog.subCategories || []).map((sc) => ({ categoryName: sc.categoryName, name: sc.name })),
    collections: catalog.collections || [],
    minPrice: catalog.minPrice,
    maxPrice: catalog.maxPrice,
    hasSeparatePriceList: catalog.hasSeparatePriceList,
    remarks: catalog.remarks,
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 1, pr: 1 }}>
        <IconButton size="small" onClick={onClose} sx={{ color: catalogTokens.color.textSecondary }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      <DialogContent sx={{ pt: 0, pb: 3 }}>
        <VendorCatalogUpload
          mode="replace"
          catalogId={catalog.id}
          initialValues={initialValues}
          onSuccess={onSuccess}
        />
      </DialogContent>
    </Dialog>
  );
};

export default VendorCatalogReplaceDialog;
